<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
       
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >OBSERVAÇÕES</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn
            v-show="$can('observacoes.create|admin.loja')"
            @click="novo()"
            color="topEnviados"
            dark
           
          >
            <v-icon>mdi-plus</v-icon>Nova
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsObs"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
      <template v-slot:item.vincular="{ item }">
      
        <v-icon
            color="green"
            class="mr-2"
            v-show="true"
            @click="vincularProduto(item)"
            >link</v-icon
          >
      </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            color="btBlue"
            class="mr-2"
            v-show="$can('observacoes.update|admin.loja')"
            @click="editobs(item)"
            >edit</v-icon
          >
          <v-icon
            color="error"
            class="mr-2"
            v-show="$can('admin.loja|observacoes.delete')"
            @click="deleteobs(item)"
            >delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogCadastro" persistent max-width="35%">
      <v-card>
     
        <v-card-title class>
          <span v-if="cadastro">Cadastrar Observação</span>
          <span v-if="cadastro == false">Editar Observação</span>
        </v-card-title>
        <v-card-text>
          <v-container>
          
             
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="obs.descricao"
                  label="Descrição"
                  filled
                  dense
                  ref="descricao_obs"
                  clearable
                  required
                ></v-text-field>
              </v-col>
             
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
   
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir essa Observação?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn>
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :timeout="3000"
      :color="sucesso"
      :bottom="true"
      absolute
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
    
    </v-snackbar>

    <v-snackbar
      :timeout="3000"
      :color="error"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarError"
    >
      {{ textSnack }}
     
    </v-snackbar>
  </v-content>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    cadastro: true,
    snackbarSuccess: false,
    snackbarError: false,
    snackbar: false,
    textSucesso: "",
    textSnack: "",
    dialogVinculaProduto:false,
    sucesso: "botao_sucesso",
    error: "error",
    footerProps: { "items-per-page-options": [30, 50, 100] },
    singleLine: true,
    dia_semana:[],
    lista_dia_semana:[
      {id:'1', dia:'domingo'},{ id:'2', dia:'segunda'},{id:'3', dia:'terça'},{id:'4', dia:'quarta'},{id:'5', dia:'quinta'},{id:'6', dia:'sexta'},{id:'7', dia:'sábado'}],
      lista_hora_inicio:['01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
      lista_hora_fim:['01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
      
    obs: {
      nome:"",
      descricao: "",
      dia_semana: null,
      hora_inicio:"",
      hora_fim:""
    },
    cats: [],
    name: "",
    autoUpdate: true,

    isUpdating: false,
    imageFile: [],
    file: "",
    files: "",

    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsObs: [],
    selectobs:null,
    itemEtapa:null,
    itemsProdutos: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",
  
   
    headers: [
     
      {
        text: "Descrição",
        value: "descricao",
        sortable: true,
        align: "left",
          width:"50%",
      },
     
     
      { text: "Ação", width:"10%",  align: "right", value: "action", sortable: false },
    ],
  }),
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
  },
  mounted() {
    
    this.observacoes();
    //this.buscaObs();
  },
  methods: {
   
   
    vincularProduto(item){
      this.dialogVinculaProduto=true
      this.selectobs = item.id
      
      this.vinculados()
    },
    remove(item) {
      const index = this.catSel.indexOf(item.name);
      if (index >= 0) this.catSel.splice(index, 1);
    },
    novo() {
      this.dialogCadastro = true;

      this.limpaCampos();
      setTimeout(() => {
        this.$refs.descricao_obs.focus()
      }, 300);
    },
    limpaCampos() {
      this.cadastro = true;
      this.obs.descricao = "";
      
    },
    
    editobs(item) {
      this.dialogCadastro = true;
      this.cadastro = false;
      this.itemEdit = item.id;
      this.obs.id = item.id;
      this.obs.descricao = item.descricao;
     
     
    },
    deleteobs(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },

    deleta() {

      this.dialogCancel=false;
      axios.delete(`montagem/obs/`+this.selItem ).then((response) => {
    
        this.observacoes();
        this.dialogCancel=false;
      }).catch((e) => {
          if (e.response.data != undefined) {
              this.dialogCancel=false;
              this.textSnack = e.response.data.error;
              this.snackbarError = true;
            }
            
        });
       
    },
    vinculados() {
      axios.get(`/montagem/obs/etapa_item_vinculado/`+this.selectobs).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.itemEtapa = response.data;
        }
      });
    },
    observacoes() {
      this.loading_table = true;
      axios.get(`/montagem/obs/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsObs = response.data;
        }
      });
    },
    gravarVinculo(){
      var formData = new FormData();

      formData.append("itemEtapa", this.itemEtapa);
      formData.append("id_obs", this.selectobs);    

      axios
        .post(`/montagem/obs_produto`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaObsSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
           // this.limpaCampos();
           // this.dialogCadastro = false;
           // this.observacoes();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });

    },
    gravar() {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      var formData = new FormData();   
      
      formData.append("descricao", this.obs.descricao);

      axios
        .post(`montagem/obs`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaObsSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            //this.obs.descricao = "";
            //this.obs.ordem = "";

            this.novo();
            this.observacoes();
          }
        })
        .catch((e) => {
          if (e.response.data != undefined) {
            if (!Array.isArray(e.response.data)) {
              let itens = [];
              for (var prop in e.response.data) {
                itens.push(e.response.data[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbarError = true;
            } else {
              this.textSnack = e.response.error;
              this.snackbarError = true;
            }
          }
        });
    },
    gravarEdicao() {
     
      var formData = new FormData();
      formData.append("id", this.obs.id);      
      formData.append("descricao", this.obs.descricao);

      axios
        .post(`/montagem/obs/editar`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaObsSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.limpaCampos();
            this.dialogCadastro = false;
            this.observacoes();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },

    buscaEtapasItemObs() {
      axios.get(`/montagem/etapa_item/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          // this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
</style>
